import { Alert, AlertIcon, Grid, Heading, Image, Link, Text } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router'

import { environment } from '@/context/AppContext'
import okAppkyLogo from '../assets/images/logo-ok-appky.svg'
import { Card, CardBody } from '../components/Card'
import { SSOLoginButtons } from './SSOLoginButtons'

export const SSOLoginForm = ({ returnUrl, error }: { returnUrl?: string, error?: boolean }) => {

  const showAdminLink = environment != 'production'

  return (
    <Grid sx={{ maxW: 'loginFormMaxW', m: 'auto', gap: 8, alignContent: 'start' }}>
      <Image src={okAppkyLogo} w={'auto'} maxW="14rem" h={12} m="auto" alt="OK appky" />

      <Card>
        <CardBody>
          <Grid sx={{ gap: 4 }}>
            <Heading as="h2" size="md">
              Centrální přihlášení
            </Heading>

            <SSOLoginButtons returnUrl={returnUrl} />

            <Text sx={{ fontSize: 'xs', color: 'gray.500' }}>
              Budete přesměrováni na stránku pro přihlášení přes SSO.
            </Text>

            {showAdminLink && <Link as={RouterLink} to={`/auth/admin?returnUrl=${returnUrl}`} color='gray.500' fontSize='xs'>Přihlásit se lokálním účtem</Link>}

            {error && <Alert status="error" sx={{ mt: 4 }} fontSize="sm">
              <AlertIcon boxSize="1.5em" mr={4} color="red.500" />
              <Text fontSize="sm">
                Do aplikace nemáte přístup.<br /> Obraťte se na vaši centrálu nebo na okappky@okholding.cz
              </Text>
            </Alert>}
          </Grid>
        </CardBody>
      </Card>
    </Grid>
  )
}
